import React from 'react'
import { Link, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import { Flex } from 'rebass'
import Layout from '../components/layout'
import { BigLetters } from '../components/Text'
import SEO from '../components/seo'

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) { // eslint-disable-line
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

const IndexPage = ({ data: { list = {} } }) => {
  const {
    node: { artists },
  } = list.edges[0] || {}

  return (
    <Layout>
      <SEO title="PLX TJÄRÖ 2019 Artister" keywords={[`PLX TJÄRÖ`, `festival`, `artister`]} />
      <Flex
        flexDirection="column"
        justifyContent="center"
        as="ul"
        px={[3, 3, 4]}
        pt="5"
        pb="180px"
        my="0"
        mx={[-3, -3, -4]}
        css={css`
          background: rgba(255, 255, 255, 0.8);
          min-height: 80vh;
          list-style: none;
        `}
      >
        {shuffle(artists).map(node => (
          <li key={node.id}>
            <Link to={`/artist/${node.slug}`}>
              <BigLetters noAnimation>{node.name}</BigLetters>
            </Link>
          </li>
        ))}
      </Flex>
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const query = graphql`
  {
    list: allContentfulArtistsCollection {
      edges {
        node {
          artists {
            id
            name
            slug
          }
        }
      }
    }
  }
`

export default IndexPage
